import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import EditPersonalInfo from "../../components/dashboard/profilePartials/EditPersonalInfo";
import ChangePassword from "../../components/dashboard/profilePartials/ChangePassword";
import { useGeneral } from "../../components/contexts/GeneralContext";

const ChangePasswordPage = () => {
 const { discountCoupons } = useGeneral();
  return (
    <>
      {/* <FullScreenLoading /> */}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />

        <BodyWrapper className="mb-0 xl:mb-0">
          <Wrapper goBack={true} component={<ChangePassword />}  />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default ChangePasswordPage;
